<template>
  <div id="pageContainer">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>

export default {
  name: 'PageContainer',
  data () {
    return {
    }
  },
  methods: {
    // 记忆最后离开时滚动条位置
    setSite (currentRouter) {
      const TabsLeaveSite = this.$store.getters.TabsLeaveSite
      const findIndex = TabsLeaveSite.findIndex(item => { return item.router === currentRouter.path })
      if (findIndex !== -1) {
        // 为div元素重新设置保存的scrollTop值
        this.$nextTick(() => {
          document.querySelector('#pageContainer').scrollTop = TabsLeaveSite[findIndex].site
        })
      }
    },
    // handleScroll (event) {
    //   console.log('querySelector', document.querySelector('#pageContainer').scrollTop)
    // },
  },
  watch: {
    '$route': {
      handler: function (currentRouter, oldRouter) {
        this.setSite(currentRouter)
      },
      deep: true,
      immediate: true
    }
  },
  mounted () {
    // document.querySelector('#pageContainer').addEventListener('touchend', this.handleScroll)
  },
  // beforeRouteLeave (to, from, next) {
  //   // 保存滚动条元素div的scrollTop值
  //   const TabsLeaveSite = this.$store.getters.TabsLeaveSite
  //   const findIndex = TabsLeaveSite.findIndex(item => { return item.router === from.path })
  //   if (findIndex > -1) {
  //     TabsLeaveSite[findIndex].site = document.querySelector('#pageContainer').scrollTop
  //   }
  //   next()
  // },
  // beforeRouteEnter (to, from, next) {
  //   next(vm => {
  //     vm.$nextTick(() => {
  //       const findIndex = vm.whiteRoute.findIndex(item => { return item.router === to.path })
  //       if (findIndex > -1) {
  //         // 为div元素重新设置保存的scrollTop值
  //         document.querySelector('#pageContainer').scrollTop = vm.whiteRoute[findIndex].site
  //       }
  //     })
  //   })
  // },
}
</script>
<style scoped>
#pageContainer {
  height: 100%;
}
</style>
